<template>
  <div v-if="info.storeInfo" class="detail-color">
    <div class="item-detail-show">
      <div class="item-detail-left">
        <div class="item-detail-big-img">
          <!-- <img :src="bigImage" alt=""> -->
          <pic-zoom :url="bigImage" :scale="2.5"></pic-zoom>
        </div>
        <div class="item-detail-img-row">
          <div class="left" @click="moveLeft">
            <Icon type="chevron-left"></Icon>
          </div>

          <div class="img-box" ref="viewBox" id="viewBox">
            <div
              class="item-detail-img-small"
              v-for="(item, index) in info.storeInfo.slider_image"
              :key="index"
              @mouseover="showBigImg(item)"
            >
              <img :src="item" alt="" />
            </div>
          </div>
          <div class="right" @click="moveRight">
            <Icon type="chevron-right"></Icon>
          </div>
        </div>
        <div class="collect" @click="collectProduct(info.storeInfo.id)">
          <Icon
            type="star"
            class="star"
            :class="info.storeInfo.userCollect ? 'on' : ''"
          ></Icon>
          <span>收藏宝贝</span>
        </div>
      </div>
      <div class="item-detail-right">
        <div class="item-detail-title">
          <p>
            {{ info.storeInfo.store_name }}
          </p>
        </div>
        <!--
        <div class="price-box">
          <div class="now-price">
            <div>正常价</div>
            <div>
              ￥<span>{{ productPrice }}</span>
            </div>
          </div>
          <div class="vip-price">
            <div>会员价</div>
            <div><span>￥</span>{{ vipProductPrice }}</div>
          </div>
        </div>
        -->
        <div class="attr-box">
          <div class="attr-name">
            <div>通用名</div>
            <div>{{ info.storeInfo.general_name }}</div>
          </div>
          <div class="attr-name">
            <div>生产商</div>
            <div>{{ info.storeInfo.manufacturer }}</div>
          </div>
        </div>
        <div
          class="item-select"
          v-for="(item, index) of info.productAttr"
          :key="index"
        >
          <div class="item-select-title">
            <p>{{ item.attr_name }}</p>
          </div>
          <div class="item-select-column">
            <div
              class="item-select-row"
              v-for="(items, indexs) in item.attr_value"
              :key="indexs"
            >
              <div
                class="item-select-box"
                @click="selectAttr(index, indexs)"
                :class="item.index === indexs ? 'item-select-box-active' : ''"
              >
                <div class="item-select-intro">
                  <p>{{ items.attr }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>        
        <div class="add-buy-car-box">
          <div class="add-buy-car">
            <span class="num">数量</span>
            <div class="input-box">
              <input type="search" v-model="count" @input="changeNum()" />
              <div class="choose-box">
                <div class="add" @click="addNum">
                  <Icon type="plus-round"></Icon>
                </div>
                <div class="del" @click="delNum">
                  <Icon type="minus-round"></Icon>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-box">
            <!--
            <template v-if="info.storeInfo.is_prescription === 0">
              <Button
                type="error"
                size="large"
                @click="goToBuy()"
                class="goto-buy btn"
                >立即购买</Button
              >
              <Button
                type="error"
                size="large"
                @click="addShoppingCartBtn()"
                class="btn goto-cart"
                ><Icon type="android-cart" class="cart"></Icon
                >加入购物车</Button
              >
            </template>
          -->
          
            <template>
              <Button
                type="error"
                size="large"
                @click="goToBuy()"
                class="btn goto-cart"
                id="commitNeed"
                >提交需求</Button
              >
            </template>
          </div>
        </div>
        <!--
        <div class="tip-box" v-if="isPrescription">
          本品为处方药，您成功预定后，药剂师会进行审核，根据处方审核结果主动与您联系。
          （如需协助请拨打 <span>0592-5911769</span>）
        </div>
        -->
        <!--
        <div class="tip-icon">
          <div class="tip-icon--item">
            <Icon type="checkmark-circled" class="checkmark"></Icon>正品保证
          </div>
          <div class="tip-icon--item">
            <Icon type="checkmark-circled" class="checkmark"></Icon>提供发票
          </div>
          <div class="tip-icon--item">
            <Icon type="checkmark-circled" class="checkmark"></Icon>隐私包装
          </div>
        </div> 
        -->
      </div>
      <Modal v-model="Contraindications" title="禁忌症提醒" @on-ok="OK">
        <p>{{ dications }}</p>
      </Modal>
    </div>
    <ShoppingList :showShopping="showShopping" v-if="isLogin"></ShoppingList>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import {
  postCartAdd,
  getCartList,
  getCollectDel,
  getCollectAdd
} from "@api/user";
import PicZoom from "vue-piczoom";
import ShoppingList from "@/components/pc/goodsDetail/ShoppingList";
export default {
  name: "ShowGoods",
  props: ["info"],
  components: {
    PicZoom,
    ShoppingList
  },
  data() {
    return {
      productPrice: 0,
      vipProductPrice: 0,
      price: 0,
      count: 1,
      imgIndex: 0,
      b_image: "",
      productSelect: {},
      uniqueId: "",
      attrCart: "", // 商品选中的属性
      collectActive: false,
      Contraindications: false,
      chooseType: 1,
      isPrescription: true,
      isLogin: false,
      showShopping: false,
      dications: "", // 禁忌症内容
      stepLength: 0, // 滚动剩余的距离
      scrollLength: 0 // 点击滚动了多少距离
    };
  },
  watch: {
    info() {
      if (this.info) {
        const value = [];
        this.info.productAttr.forEach((element, index1) => {
          element.index = 0;
          value.push(this.info.productAttr[index1].attr_values[0]);
        });
        const selectID = value.sort().join(",");
        this.attrCart = selectID;
        for (var i in this.info.productValue) {
          if (selectID === i) {
            this.uniqueId = this.info.productValue[i].unique;
          }
        }

        // 提取禁忌症
        this.info.storeInfo.instructions.forEach(item => {
          if (item.name.replace(/\s+/g, "").includes("禁忌")) {
            this.dications = item.value;
          }
        });

        this.productPrice = this.info.storeInfo.price;
        this.vipProductPrice = this.info.storeInfo.vip_price;

        this.isPrescription =
          this.info.storeInfo.is_prescription === 1 ? true : false;
      }
    }
  },
  computed: {
    // 药品主图的放大
    bigImage() {
      if (this.b_image) {
        return this.b_image;
      }
      return this.info.storeInfo.image;
    }
  },
  created() {
    this.isLogin = sessionStorage.getItem("is_login") === "1" ? true : false;
  },
  mounted() {
    setTimeout(() => {
      let boxLength = this.$refs.viewBox.offsetWidth;
      let scrollWidth = this.$refs.viewBox.scrollWidth;
      this.stepLength = scrollWidth - boxLength;
    }, 1000);
  },
  methods: {
    ...mapActions(["addShoppingCart"]),
    ...mapMutations(["SET_SHOPPING_CART"]),
    // 主图图片
    showBigImg(item) {
      this.b_image = item;
    },
    addShoppingCartBtn() {
      this.chooseType = 0;
      if (this.dications) {
        this.Contraindications = true;
      } else {
        this.addBuyBtn(this.chooseType);
      }
    },
    goToBuy() {
      this.chooseType = 1;
      if (this.dications) {
        //this.Contraindications = true;
        this.addBuyBtn(this.chooseType);
      } else {
        this.addBuyBtn(this.chooseType);
      }
    },
    addBuyBtn(buyTpye) {
      const data = {
        cartNum: this.count,
        new: buyTpye, // 购买类型 0加入购物车 1立即购买
        productId: this.info.storeInfo.id,
        uniqueId: this.uniqueId
      };
      postCartAdd(data)
        .then(
          res => {
            if (res.status === 200) {
              this.showShopping = true;
              if (buyTpye === 0) {
                getCartList().then(res => {
                  this.SET_SHOPPING_CART(res.data.valid);
                });
              } else {
                const cartId = res.data.cartId;
                this.$router.push("/order/" + cartId);
              }
            }
          },
          err => {
            this.$Modal.warning({
              content: err.msg
            });
          }
        )
        .catch(err => {
          this.$Modal.warning({
            content: err.msg
          });
        });
    },
    // 选择属性
    selectAttr(NewIndex, indexs) {
      const midProductAttr = this.info.productAttr[NewIndex];
      midProductAttr.index = indexs;
      this.info.productAttr.splice(NewIndex, 1, midProductAttr);
      // 重新获取属性id
      const value = [];
      this.info.productAttr.forEach((element, index1) => {
        value.push(this.info.productAttr[index1].attr_values[element.index]);
      });
      const selectID = value.sort().join(",");
      for (var i in this.info.productValue) {
        if (selectID === i) {
          this.uniqueId = this.info.productValue[i].unique;
          this.productPrice = this.info.productValue[i].price;
          this.vipProductPrice = this.info.productValue[i].vip_price;
        }
      }
    },
    changeNum() {
      const stock = this.info.storeInfo.stock;
      if (this.count > stock) {
        this.count = 1;
        this.$Modal.warning({
          content: "你输入的值超过库存量"
        });
      }
    },
    delNum() {
      if (this.count !== 1) {
        this.count--;
      }
    },
    addNum() {
      const stock = this.info.storeInfo.stock;
      if (this.count < stock) {
        this.count++;
      }
    },
    // 收藏商品
    collectProduct(id) {
      if (this.info.storeInfo.userCollect) {
        getCollectDel(id, "product").then(() => {
          this.$Message.success("取消收藏成功");
          this.info.storeInfo.userCollect = false;
        });
      } else {
        getCollectAdd(id, "product").then(() => {
          this.$Message.success("添加收藏成功");
          this.info.storeInfo.userCollect = true;
        });
      }
    },
    OK() {
      this.Contraindications = false;
      this.addBuyBtn(this.chooseType);
    },
    moveLeft() {
      if (this.scrollLength <= 0) {
        this.scrollLength = 0;
        return;
      }
      this.scrollLength -= 40;
      if (this.stepLength > 0) {
        document.getElementById("viewBox").scrollLeft = this.scrollLength;
      }
    },
    moveRight() {
      if (this.scrollLength > this.stepLength) {
        this.scrollLength = this.stepLength;
        return;
      }
      this.scrollLength += 40;
      if (this.stepLength > 0) {
        document.getElementById("viewBox").scrollLeft = this.scrollLength;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.item-detail-big-img >>> .magnifier-box.vertical img
  width 100%

.detail-color
  background #f4f7f7
  .item-detail-show
    width 1200px
    margin 0 auto 15px
    display flex
    flex-direction row
    background-color #fff
    padding 15px
    .item-detail-left
      width 400px
      margin-right 30px
      .item-detail-big-img
        width 400px
        height 400px
        box-shadow 0px 0px 8px #ccc
        cursor pointer
      .item-detail-img-row
        margin-top 15px
        position relative
        .img-box
          width 340px
          margin 0 auto
          white-space nowrap
          overflow-x auto
          &::-webkit-scrollbar
            width: 0
          .item-detail-img-small
            width 68px
            height 68px
            cursor pointer
            display inline-block
            margin-right 8px
            border 1px solid #ccc
            &:last-child
              margin-right 0
            img
              width 100%
              height 100%
        .left
        .right
          position absolute
          width 20px
          height 40px
          line-height 40px
          text-align center
          top 15px
          cursor pointer
          &:hover
            background #f5f5f5
        .left
          left 0
        .right
          right 0
      .collect
        margin-top 5px
        cursor pointer
        .star
          font-size 18px
          color rgb(119, 119, 119)
          &.on
            color #e93323
        &:hover .star
          animation up 1s linear
        >span
          font-size 14px
          color rgb(119, 119, 119)
    .item-detail-right
      display flex
      flex-direction column
      margin-top 10px
      font-family '宋体'
      .item-detail-title
        p
          color #333
          width 600px
          font-size 24px
          font-weight 700
          overflow hidden
          text-overflow ellipsis
          white-space nowrap
          height 70px
      .price-box
        font-size 14px
        .now-price
          display flex
          margin-bottom 10px
          div:first-child
            color #999
            margin-right 40px
            letter-spacing 4px
          div:last-child
            color #fa372e
            line-height 4px
            font-weight 700
            font-size 18px
            font-family 'Microsoft yahei'
            span
              font-size 40px
        .vip-price
          display flex
          div:first-child
            color #999
            margin-right 40px
            letter-spacing 4px
          div:last-child
            color #fa372e
            font-weight 700
            font-size 18px
            line-height 24px
            font-family 'Microsoft yahei'
      .attr-box
        margin-top 25px
        .attr-name
          display flex
          font-size 14px
          margin-bottom 5px
          div:first-child
            color #999
            margin-right 40px
            letter-spacing 4px
            width 54px
      .item-select
        display flex
        flex-direction row
        margin-top 15px
        .item-select-title
          color #999
          font-size 14px
          margin-right 40px
          line-height 38px
          width 54px
          letter-spacing 4px
          text-align-last justify
        .item-select-column
          display flex
          .item-select-row
            display flex
            flex-direction row
            margin-bottom 8px
            .item-select-box
              display flex
              flex-direction row
              align-items center
              padding 5px
              margin-right 8px
              background-color #fff
              border 0.5px solid #ccc
              cursor pointer
              &:hover
                border 0.5px solid #e3393c
              &.item-select-box-active
                border 0.5px solid #ff5c4c
                position relative
                &:after
                  content ''
                  display inline-block
                  position absolute
                  width 13px
                  height 13px
                  background #ff5c4c
                  background-image url(../../../assets/pc/images/pay/active.png)
                  background-size 100% 100%
                  right -1px
                  bottom 0
                  border-radius 0 0 4px 0
              .item-select-intro
                p
                  margin 0px
                  padding 5px
      .add-buy-car-box
        width 100%
        margin-top 5px
        display flex
        align-items center
        .add-buy-car
          margin-top 15px
          margin-bottom 10px
          display flex
          align-items center
          margin-right 40px
          .num
            font-size 14px
            color #999
            margin-right 40px
            letter-spacing 4px
            width 54px
            text-align-last justify
          .input-box
            display flex
            justify-content space-between
            border 1px solid #dcdcdc
            line-height 28px
            border-radius 2px
            width 50px
            input
              background none
              border none
              width 33px
              text-align center
              color #3C3C3C
              font-size 14px
            .choose-box
              flex 1
              .del,.add
                line-height 16px
                height 16px
                text-align center
                font-size 11px
                background #ededed
                cursor pointer
                border-left 1px solid #dcdcdc
              .add
                border-bottom 1px solid #dcdcdc
        .btn-box
          transform translateY(3px)
          font-family 'Microsoft yahei'
          .btn
            padding 6px 25px
            font-size 16px
          .goto-buy
            color #fff
            border-color #ffc105
            background #ffc105
            margin-right 10px
          .goto-cart
            background #fd3d3b
            .cart
              font-size 18px
              margin-right 10px
              color #fff
      .tip-box
        font-size 12px
        margin-left 95px
        margin-top 10px
        width 60%
        span
          color #fa372e
          letter-spacing 1px
      .tip-icon
        margin-left 95px
        display flex
        margin-top 15px
        &--item
          margin-right 20px
          color #555
          .checkmark
            color #43d513
            font-size 15px
            margin-right 5px
@keyframes up
  0%
    transform translateY(0)
  50%
    transform translateY(-10px)
  100%
    transform translateY(0)
</style>
